"use strict";
'kiwi public';
/**
 * batchedAdd prevents a flood of new inserts into state. After X inserts/sec, batch
 * each second worth of new items at the same time.
 */

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = batchedAdd;

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

function batchedAdd(singleFn, batchedFn) {
  var queue = [];
  var numInLastSec = 0;
  var isLooping = false;
  var loopInterval = 1000;

  function queueLoop() {
    numInLastSec = 0;

    if (queue.length) {
      // emptying queue before calling batchedFn in case that function triggers
      // code that needs to see that the queue has been processed.
      var q = queue;
      queue = [];
      batchedFn(q);
      numInLastSec = 0;
      (0, _setTimeout2.default)(queueLoop, loopInterval);
    } else {
      isLooping = false;
    }
  }

  function maybeStartLoop() {
    if (isLooping) {
      return;
    }

    isLooping = true;
    (0, _setTimeout2.default)(queueLoop, loopInterval);
  }

  function resetAddCounter(doResetNum) {
    if (doResetNum) {
      numInLastSec = 0;
    }

    if (!isLooping) {
      (0, _setTimeout2.default)(resetAddCounter, 1000, true);
    }
  }

  function batchFn(item) {
    numInLastSec++; // Under 1 second, queue them

    if (queue.length || numInLastSec > 3) {
      queue.push(item);
      maybeStartLoop();
    } else {
      singleFn(item);
      resetAddCounter();
    }
  }

  batchFn.queue = function getQueue() {
    return queue;
  };

  return batchFn;
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["batchedAdd"]
window._kiwi_exports.libs.batchedAdd = exports.default ? exports.default : exports;
